$(function(){
   setTimeout(function(){
    $('#klaviyo-bis-iframe').on('load',function(){
      let head = $("#klaviyo-bis-iframe").contents().find("head")
     .append($("<style type='text/css'> #klaviyo-bis-modal #container { text-align: center;}; </style>"));
      console.log('css append in iframe')
});
              },500)
     $('.u_hamberger,.u_mb_menu_overlay').click(function(){
    $('.u_hamberger').toggleClass('change');
    $('.u_mobile_menu').toggleClass('active');
    $('.u_hamberger .u_berger_line:last-child').toggleClass('u_burger_width');
    $('body').toggleClass('overflow');     
  });
  $('.u_navbar_item_link_mb').click(function(){
    $(this).toggleClass('u_mb_active_title');
    $(this).parent().find('i').toggleClass('fa-plus fa-minus');
    $(this).parent().parent().find('.u_sec_dropdown_mb').slideToggle();
  })
   $('.u_accordian_head').click(function(){               
                if($(this).next().hasClass('active'))
                {
                    $(this).next().removeClass('active').slideUp();
     $(this).find('.u_icon').addClass('plus').removeClass('minus');
                }
                else{
            $(this).next('.u_accordian_body').addClass('active').slideDown();
   $(this).find('.u_icon').addClass('minus').removeClass('plus');
                }
            })      
   $(document).on('click','.u_accordians_head',function(){
    $('.announcement-section,#shopify-section-header,button.scroll-top').addClass('u_active_sizepopup')
     $(this).next('.u_accordian_body').show();
       $('.u_sizechat_popup_block').show();
       $('body').attr('style','overflow:hidden')
        // $('html, body').scrollTop(0);
    })
     $('.u_sizechart_pop_up_overlay').click(function(){
          $('.announcement-section,#shopify-section-header,button.scroll-top').removeClass('u_active_sizepopup')
     $(this).closest('.u_accordian_body').hide();
       $('.u_sizechat_popup_block').hide();
              $('body').attr('style','overflow:auto')
    })
  $(document).on('click','.u_sign_up_block_text',function(){
       $('.u_hamberger').toggleClass('change');
    $('.u_mobile_menu').toggleClass('active');
    $('.u_hamberger .u_berger_line:last-child').toggleClass('u_burger_width');
    $('body').toggleClass('overflow');  
     const currentLocale = window.Shopify.locale || document.documentElement.lang || "en";
  console.log('current locale',currentLocale)
  if(currentLocale == 'de'){
    window._klOnsite = window._klOnsite || [];
window._klOnsite.push(['openForm', 'RKwNb3']);
  }
  else{
    window._klOnsite = window._klOnsite || [];
window._klOnsite.push(['openForm', 'T5afvT']);
  }
  })
})